import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;
const API_KEEPER = import.meta.env.VITE_API_KEEPER;

const AgentInfoService = {
    getUser: async (id) => axios.get(API_KEEPER + `/user/get/${id}`).then(({ data }) => data).catch((err) => { throw err }),

    getInfo: async () => axios.get(API_KEEPER + `/user/get-info`).then(({ data }) => data).catch((err) => { throw err }),

    getImage: async (id) => {
        const response = await axios.get(API_URL + `/user/getImage/${id}`, { responseType: "blob" });

        return URL.createObjectURL(response.data);
    }
}

export default AgentInfoService;